import { Rate, useRepositoryQuery } from '@mews-commander/data-access';
import { keyById } from '@mews/fp';

export const useRatesQuery = (enterpriseId: string, serviceId: string) =>
    useRepositoryQuery(
        'rates',
        'getAll',
        {
            enterpriseIds: [enterpriseId],
            serviceIds: [serviceId],
        },
        {
            select: (result) => ({
                ...result,
                defaultRate: result.rates?.find((r) => r.isDefault),
                ratesById: keyById(result.rates) as Record<string, Rate | undefined>,
            }),
        }
    );
